import { FC, Fragment } from "react";
import { Box, Typography } from "@mui/material";
import { FiltersCombinationOperatorType } from "@/components/pages/common/filters-tree/utils/types/common";
import {
  FilterItemNode,
  ResourceExplorerPossibleFilterV2,
} from "@/services/cloudchipr.api";
import { FilterTreeDisabledItemFields } from "@/components/pages/common/filters-tree/filters-disabled-view/components/FilterTreeDisabledItemFields";

interface FilterTreeDisabledItemProps {
  index: number;
  filter: FilterItemNode;
  parentOperator: FiltersCombinationOperatorType;
  possibleFilters: ResourceExplorerPossibleFilterV2[];
}

export const FilterTreeDisabledItem: FC<FilterTreeDisabledItemProps> = ({
  index,
  filter,
  parentOperator,
  possibleFilters,
}) => {
  return (
    <Fragment>
      <Box minWidth={62}>
        <Typography variant="body2" color="text.secondary">
          {index === 0 ? "Where" : parentOperator.toUpperCase()}
        </Typography>
      </Box>

      <FilterTreeDisabledItemFields
        filter={filter}
        possibleFilters={possibleFilters}
      />
    </Fragment>
  );
};
